module.exports = __webpack_public_path__ + "img/bg_room@2x.b2b8a981.png";